import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { Navigate } from 'react-router-dom';
import { useAccount } from '../../context/AccountContext';

const SITE_ADDRESS = gql`
  query TinycmsSiteAddress($id: ID!) {
    account(id: $id) {
      id
      publicSlug
    }
  }
`;

/**
 * A tinycms account without a site address hasn't finished signing up (it
 * left after the account step), so it goes back to signup, which resumes at
 * Site address. Connecting an agent can be skipped there, so it isn't checked.
 */
export function FinishSignup() {
  const { accountId, selectedAccount } = useAccount();
  // Only tinycms signups; other accounts reached on this host have no site to finish.
  const tinycms = selectedAccount?.products?.some(
    (p) => p.product === 'tinycms' && p.status === 'active'
  );
  const { data } = useQuery(SITE_ADDRESS, {
    variables: { id: accountId },
    skip: !accountId || !tinycms,
    fetchPolicy: 'cache-and-network',
  });
  const account = data?.account;
  if (!tinycms || !account || account.id !== accountId || account.publicSlug) return null;
  return <Navigate to="/signup" replace />;
}
